<template>
  <div>
    <md-dialog
      :md-active.sync="showDialog"
      :md-click-outside-to-close="false"
      v-resize="onResize"
    >
      <md-dialog-title>Verification Submitted!</md-dialog-title>
      <md-dialog-content>
        Thank you for providing your information. You can now safely close this window
        which will return you to <strong>ABCwidgets.com</strong>.
        <div class="complete_content">
          <img src="@/assets/accept_icon.png" class="sucess_avatar" />
          <div>
            <div>Your SIDV code:</div>
            <div class="top_pad">
              <span class="verify_code"><strong>QVK8VDA7</strong></span>
              <button
                class="copy_button"
                type="button"
                v-clipboard:copy="message"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <img src="@/assets/copy_icon.png" />
              </button>
            </div>
            <div class="mt-3">
              <strong>TIP:</strong> This SIDV code will expire on 31-Oct-2022
            </div>
          </div>
        </div>
        <md-dialog-actions>
          <div>
            <md-button class="md-raised md-primary btn-element" @click="close_window()"
              >Close Window</md-button
            >
          </div>
        </md-dialog-actions>
        <div>
          <img class="logo-size" src="@/assets/logo.png" />
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "CompleteExist",

  data: () => ({
    message: "QVK8VDA7",
    showDialog: true,
  }),

  methods: {
    close_window() {
      this.$router.push({ name: "Verify" });
    },
    onCopy: function (e) {
      console.log("sadfS");
      alert("You just copied the following text to the clipboard: " + e.text);
    },
    onError: function (e) {
      alert("Failed to copy the text to the clipboard");
      console.log(e);
    },
    onResize({ width, height }) {
      window.onResizeHandler(width, height);
    },
  },

  mounted() {}
};
</script> 

<style lang="scss" scoped>
.copy_button {
  border: unset;
  width: 35px;
  height: 35px;
  background-color: white;
  padding-left: 5px;
}
.top_pad {
  padding-top: 20px;
}
.verify_code {
  font-size: 20px;
  padding: 10px;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 10%;
  border: 2px dotted black;
  border-radius: 10px;
}

.sucess_avatar {
  width: 150px;
}

.complete_content {
  padding: 25px;
  display: flex;
  justify-content: center;
}

.logo-size {
  width: 150px;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #73c773;
  border-radius: 10px;
  padding-left: 40px;
  padding-right: 40px;
  color: white !important;
}

.md-dialog-actions {
  justify-content: center;
}

.btn-element {
  margin: 1% !important;
  color: black !important;
  font-size: 12px;
}

ul {
  margin-top: 1rem !important;
  margin-bottom: 0rem !important;
}

.md-dialog {
  ::v-deep .md-dialog-container {
    max-width: 500px;
    border-radius: 20px !important;
    border: 3px solid black;
  }
}
</style>